import { getTreeIndex } from "routes/schedule/lib/getTreeIndex"

export function getTreeItem(id, hint) {
    return getTreeIndex().retrieve(id, hint)
}
